import { Spinner } from "flowbite-react";

  
const ResultSpinner = () => (
    <div id="result" className="mt-5 py-2">
      <Spinner size="lg" className="fill-blue-600" aria-label="Default status example" />
    </div>
)

export default ResultSpinner;